import { convertString } from "../../utils/convertString";
import {
  Box,
  Button,
  HStack,
  Input,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { DropDown } from "../DropDown/DropDown";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
// import { Zone } from "@/services/state/analytics/analytics-interface";

export const EdgeNamingModal = ({
  isOpen,
  onClose,
  coordinates,
  //   positions,
  initialName,
  onEdgeSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  coordinates: { x: number; y: number };
  //   positions: { x: number; y: number };
  initialName: string;
  onEdgeSave: (name: string) => void;
}) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(initialName);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleSave = () => {
    if (name && name.trim() !== "") {
      onEdgeSave(name.trim());
      setName("");
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        position="fixed"
        top={`${coordinates.y}px`}
        left={`${coordinates.x}px`}
        p={4}
      >
        <Text fontSize="lg" fontWeight="bold" mb={4}>
          Edit Edge Label
        </Text>
        <Box>
          <Input
            placeholder="Enter label"
            size="md"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Box>
        <HStack justifyContent="flex-end" mt={4}>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
        </HStack>
      </ModalContent>
    </Modal>
  );
};
